import request from '@/utils/request'

let getList=()=>request.get('/api/country/list')

export default {
  getList
}